<template lang="pug">
Card.selections-card
  template(#header)
    .title {{ $t('selections.userMPRN.title') }}
      InfoTooltip(:message=" $t('selections.uploadMPRN.tooltip')" :direction="bottomTooltip ? TooltipPosition.bottom : undefined")
  template(#content)
    .wrapper
      SearchInput(
        v-model="mprn" 
        :placeholder="$t('selections.userMPRN.placeholder')" 
        :submit-label="$t('selections.userMPRN.button')" 
        :loading="isLoading"
        @search="submitMPRN()"
        @keyup="onKeyUp")
      SelectionErrorMessage(v-if="mprnValid === false" :message="mprnError?.message ")
      .details(v-if="mprnDetails")
        .data
          .mprn.info
            .info-label {{ $t('selections.mprnInfo.address') }}
            .info-value {{ mprnDetails.address.addressLine1 }}, {{ mprnDetails.address.addressLine2 }}, {{ mprnDetails.address.postCode }}
</template>
<script lang="ts">
import { useSelections } from "@/store/selections";
import { defineComponent, ref } from "vue";
import { storeToRefs } from "pinia";
import Card from "primevue/card";
import SearchInput from "@/components/forms/components/SearchInput.vue";
import SelectionErrorMessage from "@/components/forms/components/SelectionErrorMessage.vue";
import InfoTooltip from "@/components/commons/InfoTooltip.vue";
import { useSettings } from "@/store";
import { TooltipPosition } from "@/types";

export default defineComponent({
  name: "UserMPRN",
  components: {
    Card,
    SearchInput,
    SelectionErrorMessage,
    InfoTooltip,
  },
  setup() {
    const selections = useSelections();
    const { mprn, mprnValid, mprnError, mprnDetails } = storeToRefs(selections);
    const { validateMPRN, resetMPRNValidity } = selections;

    const buttonMPRN = ref();
    const isLoading = ref(false);

    const bottomTooltip = !!useSettings().hasCostsAndSavings;

    function onKeyUp(event: KeyboardEvent) {
      if (event.key === "Enter") {
        submitMPRN();
      } else {
        mprn.value = mprn.value?.replace(/[^\d]/g, "");
        resetMPRNValidity();
      }
    }

    async function submitMPRN(): Promise<void> {
      isLoading.value = true;
      await validateMPRN();
      isLoading.value = false;
    }

    return {
      mprn,
      mprnValid,
      submitMPRN,
      onKeyUp,
      isLoading,
      buttonMPRN,
      mprnError,
      bottomTooltip,
      mprnDetails,
      TooltipPosition,
    };
  },
});
</script>
<style scoped lang="scss">
.title {
  display: inline;

  &:deep(.info-tooltip) {
    vertical-align: text-top;
  }
}
.details {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  .data {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .info {
      display: flex;
      flex-direction: column;

      .info-label {
        font-weight: 600;
      }

      .info-message {
        font-size: 0.8rem;
        padding-top: 0.2rem;
        a {
          text-decoration: underline;
          color: $secondary-color;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
